var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.checked)?_c('NbIcon',{staticClass:"text-success",attrs:{"icon":"check","size":_vm.size}}):_c('NbIcon',{staticClass:"text-danger",attrs:{"icon":"x","size":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }